{
  "salon-card": {
    "text": {
      "and-x-more": "và {{nr}} nữa",
      "points": "điểm"
    }
  }
}
